import { edge } from "@antv/g2plot/lib/adaptor/geometries";
import { register } from "@antv/x6-react-shape";
import { stroke } from "@antv/x6/lib/registry/highlighter/stroke";
import { Button, Form, Image, Modal, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";

export default function configurePowerMeterNode(
  node,
  graph,
  modalApi,
  powerMeterSelection
) {
  let formInstance;

  function ConfigurationForm({ node, graph, modalApi, powerMeterSelection }) {
    const [form] = Form.useForm();
    formInstance = form;

    function onFinish(values) {
      node.setProp({
        display: values.display,
        label: powerMeterSelection?.find((x) => x.value == values.id)?.label,
      });
      graph.updateCellId(node, values.id);
      Modal.destroyAll();
    }

    return (
      <>
        <Form
          form={form}
          id="myForm"
          layout="vertical"
          onFinish={onFinish}
          clearOnDestroy
          initialValues={{
            display: node.getProp("display", "simple"),
            id: powerMeterSelection?.some((x) => x.value == node?.id)
              ? node.id
              : null,
          }}
        >
          <Form.Item
            label="Display Type"
            name={"display"}
            rules={[
              {
                required: true,
                message: "Please input the title of collection!",
              },
            ]}
          >
            <Select>
              <Select.Option value="simple">Simple</Select.Option>
              <Select.Option value="detailed">Detailed</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Power Meter"
            name={"id"}
            rules={[
              {
                required: true,
                message: "Please input the title of collection!",
              },
              {
                validator: (_, value, callback) => {
                  if (graph.hasCell(value) && node.id != value) {
                    return callback("Duplicate Power Meter");
                  } else return callback();
                },
              },
            ]}
          >
            <Select
              optionFilterProp="label"
              showSearch
              filterSort={(a, b) =>
                (a?.label ?? "")
                  .toLowerCase()
                  .localeCompare((b?.label ?? "").toLowerCase())
              }
              options={powerMeterSelection}
            ></Select>
          </Form.Item>
        </Form>
      </>
    );
  }

  modalApi?.confirm({
    title: "Configure Power Meter",
    icon: null,
    closable: true,
    maskClosable: true,
    content: (
      <>
        <ConfigurationForm
          node={node}
          graph={graph}
          modalApi={modalApi}
          powerMeterSelection={powerMeterSelection}
        />
      </>
    ),
    footer: (_, { OkBtn, CancelBtn }) => (
      <>
        <CancelBtn />
        <Button form="myForm" htmlType="submit" type="primary">
          Save
        </Button>
      </>
    ),
  });
}
